<div
	class="flex flex-col gap-5 rounded-xl border-grey bg-grey-veryLight p-5 mt-5 item-center justify-center mb-5"
>
	<div
		*ngIf="isCommercial"
		class="flex flex-col items-center justify-center px-10 gap-5"
	>
		<app-icon class="text-orange text-4xl" [icon]="ICON.WARNING"></app-icon>
		<p class="text-xl font-bold">Property type not supported</p>
		<p class="mx-5 text-sm text-center w-2/3">
			Policies for commercial properties must be ordered directly from Stewart
			Title online via
			<span class="text-blue-500 font-bold hover:underline"
				><a
					externalNavInterceptor
					href="https://www.stepsonline.ca/smartorder/home"
					target="_blank"
					[testHook]="testHooks.SmartOrderFormLink"
					>Smart Order Form</a
				></span
			>
			or by phone at 888-667-5151.
		</p>
	</div>
	<div
		*ngIf="isOther"
		class="flex flex-col items-center justify-center px-10 gap-5"
	>
		<app-icon class="text-orange text-4xl" [icon]="ICON.WARNING"></app-icon>
		<p class="text-xl font-bold">Property type not supported</p>
		<p class="mx-5 text-sm text-center w-2/3">
			The property type you've selected isn't supported by Stewart Title. Please
			select an alternative option.
		</p>
	</div>
	<div
		*ngIf="isMobileHome"
		class="flex flex-col items-center justify-center px-10 gap-5"
	>
		<app-icon class="text-orange text-4xl" [icon]="ICON.WARNING"></app-icon>
		<p class="text-xl font-bold">
			Property type must be discussed with Stewart Title
		</p>
		<p class="mx-5 text-sm text-center w-2/3">
			Separate underwriting requirements may apply. Please contact an
			underwriter at 416.307.3300 or toll-free at 888.667.5151.
		</p>
	</div>
	<div
		*ngIf="!isCommercial && !isOther && !isMobileHome && outOfOntario"
		class="flex flex-col items-center justify-center px-10 gap-5"
	>
		<app-icon class="text-orange text-4xl" [icon]="ICON.WARNING"></app-icon>
		<p class="text-xl font-bold">Property location not supported</p>
		<p class="mx-5 text-sm text-center w-2/3">
			Policies for properties outside of Ontario must be ordered directly from
			Stewart Title online via
			<span class="text-blue-500 font-bold hover:underline"
				><a
					externalNavInterceptor
					href="https://www.stepsonline.ca/smartorder/home"
					target="_blank"
					[testHook]="testHooks.SmartOrderFormLink1"
					>Smart Order Form</a
				></span
			>
			or by phone at 888-667-5151.
		</p>
	</div>
	<div
		*ngIf="orderValid && !status"
		class="flex flex-col items-center justify-center px-10 gap-5"
	>
		<app-icon [icon]="ICON.CHECK" class="text-green text-4xl"></app-icon>
		<p class="text-xl font-bold">Ready to begin order!</p>
		<p>
			You've collected everything you need to begin your order with Stewart
			Title
		</p>
	</div>
	<div
		*ngIf="orderValid && status === StewartStatus.NOT_SUBMITTED"
		class="flex flex-col items-center justify-center mx-auto max-w-5xl px-10 gap-5"
	>
		<app-icon class="text-orange text-4xl" [icon]="ICON.WARNING"></app-icon>
		<p class="text-xl font-bold">Order not submitted</p>
		<p>Please submit your order for Stewart Title to review.</p>
		<app-stewart-message-container
			[testHook]="testHooks.StewartMessageContainer"
		></app-stewart-message-container>
	</div>
	<div
		*ngIf="orderValid && status === StewartStatus.ORDER_RESUBMIT_REQUIRED"
		class="flex flex-col items-center justify-center mx-auto max-w-5xl px-10 gap-5"
	>
		<app-icon class="text-orange text-4xl" [icon]="ICON.WARNING"></app-icon>
		<p class="text-xl font-bold">Order resubmission required</p>
		<p>
			Changes to your file have impacted your order. Please resubmit to
			continue.
		</p>
		<app-stewart-message-container
			[testHook]="testHooks.StewartMessageContainer1"
		></app-stewart-message-container>
	</div>
	<div
		*ngIf="!orderValid && canSubmit"
		class="flex flex-col items-center justify-center px-10 gap-5"
	>
		<app-icon class="text-orange text-4xl" [icon]="ICON.WARNING"></app-icon>
		<p class="text-xl">Missing fields</p>
		<atomic-message-bar
			*ngIf="showPriorityWarning"
			type="warn"
			[shadow]="false"
			[testHook]="testHooks.MessageBar"
		>
			<p>
				A
				<span
					class="cursor-pointer underline"
					(click)="editPriority()"
					[testHook]="testHooks.EditPrioritySpan"
					>New Mortgage</span
				>
				and an
				<span
					class="cursor-pointer underline"
					(click)="editPriority()"
					[testHook]="testHooks.EditPrioritySpan1"
					>Encumbrance (Remain)</span
				>
				have the same priority selected.
			</p>
		</atomic-message-bar>
		<p class="mx-5 text-sm text-center">
			The following fields must be added to Closer to start your order
		</p>
		<div class="flex flex-col flex-1 justify-center px-10 w-96">
			<div
				class="items-center text-center"
				*ngFor="let fieldSection of missing"
			>
				<p class="mb-1 mt-5 font-bold">{{ fieldSection.sectionName }}</p>
				<div
					*ngFor="let field of fieldSection.fields"
					class="flex mt-2 items-center justify-center text-center"
				>
					<app-icon [icon]="ICON.ERROR" class="text-red mr-3"></app-icon>
					<app-anchor
						*ngIf="field.fieldName !== 'Closing date'"
						(click)="field?.url || field?.openDrawer()"
						[url]="field?.url"
						[queryParams]="field.queryParams ?? backUrlParams"
						type="static"
						[testHook]="testHooks.Link"
						>{{ field.fieldName }}</app-anchor
					>
					<button
						*ngIf="field.fieldName === 'Closing date'"
						type="button"
						(click)="openKeyDatesDrawer($event)"
						class="text-green-600 underline"
					>
						{{ field.fieldName }}
					</button>
				</div>
			</div>
		</div>
	</div>
	<div class="flex flex-col items-center justify-center px-10 gap-5">
		<app-button *ngIf="changePropertyButtonText" [testHook]="testHooks.Button"
			><app-anchor
				[cssClasses]="['text-green']"
				[icon]="ICON.EDIT"
				[url]="propertyUrl"
				[queryParams]="backUrlParams"
				[testHook]="testHooks.Link1"
				>{{ changePropertyButtonText }}</app-anchor
			></app-button
		>
		<app-button
			*ngIf="canSubmit && status !== StewartStatus.ORDER_RESUBMIT_REQUIRED"
			(click)="openPortal()"
			[icon]="ICON.RESEND"
			[disabled]="!orderValid"
			[testHook]="testHooks.StartOrderButton"
			>Start order</app-button
		>
		<app-button
			*ngIf="canSubmit && status === StewartStatus.ORDER_RESUBMIT_REQUIRED"
			(click)="openPortal()"
			[icon]="ICON.RESEND"
			[disabled]="!orderValid"
			[testHook]="testHooks.ResubmitOrderButton"
			>Resubmit order</app-button
		>
		<div class="w-3/4 mx-auto flex gap-2 items-center justify-between mt-1">
			<hr class="w-1/2 mt-2" />
			<p>OR</p>
			<hr class="w-1/2 mt-2" />
		</div>
		<app-stewart-footer
			[allowCancel]="true"
			[status]="status"
		></app-stewart-footer>
	</div>
</div>
